{
  "achievements": "Achievements",
  "advanced": "Advanced",
  "all": "All",
  "antiFakeProtection": "Anti-Fraud Protection",
  "antiFakeProtectionText": "All claims are verified server-side to prevent fraudulent activity.",
  "approvedClaims": "Approved Claims",
  "approvedExalt": "Approved EXALT",
  "beginner": "Beginner",
  "claim5Exalt": "Claim 5 EXALT",
  "claimDailyMining": "Claim Daily Mining Reward",
  "claimDailyRewardDesc": "Claim your 5 EXALT daily reward.",
  "claimDailyRewardDescription": "Claim 5 EXALT every day.",
  "claimFailed": "Claim failed.",
  "claimedToday": "Claimed Today",
  "completed": "Completed",
  "completedTasks": "Completed Tasks",
  "cooldown": "Cooldown",
  "correctAnswerRewardAdded": "Correct answer! Reward added.",
  "cryptoBasics": "Crypto Basics",
  "dailyMiningRate": "Daily Mining Rate",
  "dailyReward": "Daily Reward",
  "dailyRewardClaimed": "Daily reward claimed.",
  "dailyStreak": "Daily Streak",
  "days": "Days",
  "distributed": "Distributed",
  "downloadCertificate": "Download Certificate",
  "duration": "Duration",
  "exaltExchangeUser": "Exalt Exchange User",
  "exaltMiningPool": "EXALT Mining Pool",
  "failedLoadRewards": "Failed to load rewards.",
  "firstLesson": "First Lesson",
  "intermediate": "Intermediate",
  "learnEarn": "Learn & Earn",
  "learnEarnSubtitle": "Watch lessons, complete quizzes and earn EXALT rewards.",
  "learnEarnTitle": "Learn & Earn",
  "learnerAchievement": "Learner Achievement",
  "learningLevel": "Learning Level",
  "learningProgress": "Learning Progress",
  "lessonCompleted": "Lesson completed successfully.",
  "level": "Level",
  "loadingLessons": "Loading lessons...",
  "locked": "Locked",
  "masterAchievement": "Master Achievement",
  "miningProtectionNote": "Mining rewards are protected against automated and duplicate claims.",
  "miningRewardSubmitted": "Mining reward claim submitted.",
  "myRewardClaims": "My Reward Claims",
  "noAchievements": "No achievements yet.",
  "noActivityYet": "No activity yet.",
  "noMinersYet": "No miners yet.",
  "noReferrersYet": "No referrers yet.",
  "noRewardClaimsYet": "No reward claims yet.",
  "oneClaimEvery24Hours": "One claim allowed every 24 hours.",
  "optionAfterPayment": "After confirmed payment",
  "optionAnyTime": "Any time",
  "optionBeforePayment": "Before payment",
  "optionDeleteTokens": "Delete tokens",
  "optionLockTokens": "Lock tokens for rewards",
  "optionPrivateKey": "Share private key",
  "optionProtectWallet": "Protect wallet keys",
  "optionSendTokens": "Send tokens away",
  "optionUnknownLinks": "Use unknown links",
  "p2pSafety": "P2P Safety",
  "pendingValue": "Pending Value",
  "questionCrypto": "What is the safest rule in crypto?",
  "questionP2p": "When should you release crypto in P2P?",
  "questionStaking": "What does staking mean?",
  "quiz": "Quiz",
  "recentActivity": "Recent Activity",
  "referralRewardNote": "Referral rewards are credited after admin verification.",
  "referralRewardPool": "Referral Reward Pool",
  "referrals": "Referrals",
  "reward": "Reward",
  "rewardClaim": "Reward Claim",
  "rewardClaimFailed": "Reward claim failed.",
  "rewardClaimed": "Reward claimed successfully.",
  "rewardCompleted": "Reward completed.",
  "rewardFailed": "Reward claim failed.",
  "searchLessons": "Search lessons...",
  "securityReview": "Security Review",
  "serverError": "Server error.",
  "sessionExpired": "Session expired. Please login again.",
  "stakingGuide": "Staking Guide",
  "startLesson": "Start Lesson",
  "submitQuizClaimReward": "Submit Quiz & Claim Reward",
  "submitting": "Submitting...",
  "todayClaims": "Today's Claims",
  "topLearners": "Top Learners",
  "topMiners": "Top Miners",
  "topReferrers": "Top Referrers",
  "totalClaims": "Total Claims",
  "totalPool": "Total Pool",
  "totalRewards": "Total Rewards",
  "used": "Used",
  "videoCryptoBasics": "What is crypto and how do exchanges work?",
  "videoP2pSafety": "How to trade safely with P2P users",
  "videoStakingGuide": "How staking rewards work",
  "viewAgain": "View Again",
  "wrongAnswerTryAgain": "Wrong answer. Please try again.",
  "xpPoints": "XP Points",
  "you": "You"
}